import { createBrowserHistory } from 'history'; // eslint-disable-line
import { getFieldFromMeta } from '4ff-lib-foundation/lib/AppFrame/publicAPI/config';

// it's required for support of URI prefix
const history = createBrowserHistory({
  basename: getFieldFromMeta('appPrefix'),
  stringifyQuery: (query) => {
    let resultQuery = '';
    const keys = Object.keys(query);
    keys.forEach((key, idx) => {
      resultQuery += `${key}=${query[key]}`;
      if (idx !== keys.length - 1) {
        resultQuery += '&';
      }
    });

    return resultQuery;
  },
});

export default history;
